export default __webpack_public_path__ + "static/media/team.0813183d.jpg";